var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuItem',_vm._b({on:{"click":function($event){$event.stopPropagation();return _vm.toggleSidebar.apply(null, arguments)}}},'MenuItem',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }